<button mat-icon-button [matMenuTriggerFor]="notificationMenu" [matBadge]="totalUnreadCount"
    [matBadgeHidden]="totalUnreadCount === 0" matBadgeColor="warn"
    [matTooltip]="'notification.Notifications' | translate" (menuOpened)="onMenuOpened()" (menuClosed)="onMenuClosed()">
    <mat-icon>notifications</mat-icon>
</button>

@let conectedtxt = isConnected ? ('notification.Conected' | translate) : ('notification.Disconnected' | translate);
<mat-menu #notificationMenu="matMenu" xPosition="before" class="notification-menu"
    [class.notification-menu--empty]="notifications.length === 0">
    <div class="notification-menu-shell" (click)="$event.stopPropagation()">
        <div class="notification-menu-header">
            <div class="header-connection">
                <h3>{{'notification.Notifications' | translate}}</h3>
                <span class="connection-status" [class.connected]="isConnected">
                    {{ conectedtxt }}
                </span>
            </div>
            @if (showDevWebSocketToggle) {
            <div class="dev-ws-toggle">
                <span class="dev-ws-toggle__label">{{ 'notification.devWebSocketToggle.label' | translate }}</span>
                <mat-slide-toggle
                    [checked]="devWebSocketEnabled"
                    (change)="onDevWebSocketToggle($event.checked)"
                    [matTooltip]="(devWebSocketEnabled ? 'notification.devWebSocketToggle.tooltipOn' : 'notification.devWebSocketToggle.tooltipOff') | translate">
                </mat-slide-toggle>
            </div>
            }
            <mat-divider></mat-divider>
        </div>

        <div #menuBody class="notification-menu-body">
            @if (notifications.length === 0) {
            <div class="no-notifications">
                <mat-icon>notifications_none</mat-icon>
                <p>{{'notification.Not_Notification' | translate}}</p>
            </div>
            } @else {
            <div class="notification-list">
                @for (notification of notifications; track notification.id) {
                <div class="notification-list-item" [attr.data-notification-id]="notification.id">
                    <app-notification-host [notification]="notification" (activate)="activateNotification($event)"
                        (dismiss)="deleteNotification($event)">
                    </app-notification-host>
                </div>
                }
            </div>
            }
        </div>
    </div>
</mat-menu>